import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, IState } from '..';
import { ITemplate } from '../../../entities/organization';
import { getTemplates } from './thunks';

export const useTemplates = (): { templates: ITemplate[]; ready: boolean } => {
    const dispatch = useDispatch<AppDispatch>();
    const templates = useSelector((state: IState) => state.organization.templates || [], shallowEqual);
    const loaded = useSelector((state: IState) => !!state.organization.templatesLoaded);
    const loading = useSelector((state: IState) => !!state.organization.templatesLoading);

    useEffect(() => {
        if (!loaded && !loading) {
            dispatch(getTemplates());
        }
    }, [dispatch, loaded, loading]);

    return { templates, ready: loaded };
};
